enum clientRoutes {

  INDEX = "/",
  INFOS_CLIENT = "infosClient",
  ORDERS = "commandes",
  CHANGE_PASSWORD = "changePass"

}
export default clientRoutes;
